import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fileInfo } from "../../apis/fileinfo";
import config from "../../env.json";
import {
  setFromNumber,
  setNumber,
  setOtpValue,
  setPdfId,
  setRecepientName,
  setFormId,
  setMsgChannel,
} from "../../app/slice/pdfslice";
import VerificationModal from "../../components/Verification/VerificationModal";
import "./NumberInput.css";
import CustomToast from "../Toast/Toast";

export default function NumberInput() {
  const dispatch = useDispatch();
  const [disableButton, setDisableButton] = useState(true);
  const [newMobileNumber, setNewMobileNumber] = useState<any>();
  const [newMobileNumberObject, setNewMobileNumberObject] = useState<any>({});
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "error",
  });

  /* istanbul ignore next */
  const getNewMobileNumber = (e: any) => {
    setNewMobileNumber(e.target.value);

    if (e.target.value.length < 4) {
      setDisableButton(true);
      setError(true);
      if (e.target.value.length === 0) {
        setDisableButton(false);
        setError(false);
      }
    } else if (e.target.value.length == 4) {
      setDisableButton(false);
      setError(false);
    }
  };
  /* istanbul ignore next */
  const numberVarification = () => {
    if (newMobileNumber.length < 4) {
      setDisableButton(true);
    } else {
      if (window.location.pathname.length > 1) {
        const pathParts = window.location.pathname.split("/");
        const countryCode = pathParts[1];
        const id = pathParts[2].split(".")[0];
        const baseUrl = window.location.origin;
        const zoneDomain = baseUrl + "_" + countryCode;
        localStorage.setItem("ZoneNm", zoneDomain);

        dispatch(setPdfId(id));
        fileInfo(id, newMobileNumber, (res: any) => {
          console.log(res);
          if (res) {
            dispatch(setNumber(res.ToNumber));
            dispatch(setOtpValue(res.OTP));
            dispatch(setFromNumber(res.FromNumber));
            dispatch(
              setRecepientName(res.RecepientName ? res.RecepientName : ""),
            );
            dispatch(setMsgChannel(res.MsgChannel ? res.MsgChannel : ""));
            dispatch(setFormId(res.FormId));
            localStorage.setItem("formBlobStorageUrl", res.formBlobStorageUrl);
            if (
              res.ToNumber.substring(res.ToNumber.length - 4) == newMobileNumber
            ) {
              setDisableButton(false);
              setShowModal(true);
              setError(false);
            } else {
              setError(true);
              setDisableButton(true);
              setToast({
                show: true,
                message: "Please Enter valid last digits",
                type: "error",
              });
            }
          } else {
            setError(true);
            setDisableButton(true);
            setToast({
              show: true,
              message: "Server error occurred. Please try again later.",
              type: "error",
            });
          }
        });
      }
    }
  };

  return (
    <>
      <CustomToast
        show={toast.show}
        message={toast.message}
        type={toast.type as "error" | "success"}
        onClose={() =>
          setToast({
            ...toast,
            show: false,
          })
        }
      />
      <div className="input-wrapper">
        {showModal ? (
          <VerificationModal
            show={showModal}
            newMobileNumber={newMobileNumber}
            handleClose={() => {
              setShowModal(false);
            }}
          />
        ) : null}
        <div className="number-input-container">
          <input
            className="mobile-number-input"
            data-testid="mobile-numberInput"
            maxLength={4}
            value={newMobileNumber}
            onChange={getNewMobileNumber}
            placeholder="Enter last 4 digit of your mobile number"
            required
          />
          {error ? (
            <span className="error">Please enter valid digits.</span>
          ) : null}
        </div>

        <div className="btn-wrapper">
          <button
            className={
              disableButton ? "btn-primary disable-btn" : "btn-primary"
            }
            //  style={{ opacity: disableButton ? 1 : 0.4 }}
            disabled={disableButton}
            onClick={() => {
              numberVarification();
            }}
          >
            Verify
          </button>
        </div>
      </div>
    </>
  );
}
